import payments from '../payments/payments';
import { Section } from "../jobs-flow/Section";
import Route from "./route.js";

require('daterangepicker');

export default class serviceList {
    constructor() {
        this.searchParams = new Proxy(new URLSearchParams(window.location.search), {
            set: (searchParams, prop, newValue) => {
                searchParams.set(prop, newValue);
                window.location.search = searchParams.toString();
                return true;
            },
        });

        this.showOrdersMapByDate();
        this.showWarningModal();
        payments.autoRefresh('/service-list');
        this.initPagination();
        this.mobileActionsInit();

        Route.init();
    }

    showOrdersMapByDate(){
        $('head script[src*="maps.googleapis.com/maps-api-v3"]').remove();
        $('head script[src*="maps.googleapis.com/maps/api"]').remove();
        $('#app').off('click', 'a[data-show-map]').on('click', 'a[data-show-map]', function(e){
            e.preventDefault();
            let ordersDate = $(this).data('map-date');
            const dateRange = {
                'date-range': {
                    start: ordersDate,
                    end: ordersDate
                }
            }
            $.ajax({
                type: 'GET',
                data: dateRange,
                url: '/service-list/get-orders-map-by-date/',
                success: function (response) {
                    $('#form-container').html(response);
                    $('#map-modal').modal('show');
                    $('#close-map-button').off('click').on('click',()=>{
                        $('head script[src*="maps.googleapis.com/maps-api-v3"]').remove();
                        $('head script[src*="maps.googleapis.com/maps/api"]').remove();
                    })
                }
            });
        });
    }
    showWarningModal(){
        $('body').on('click', '.warning-info-icon', function(e) {
            $('.order-reason').text($(this).data('reason'));
            if ($(this).data('reason')!=='') {
                $('.order-reason').parent().addClass('mb-30');
            }
            $('.remove_warning').data('class_id', $(this).data('class_id'));
            $('.remove_warning').data('class_type', $(this).data('class_type'));
            $('#order-warning-modal').modal('show');
        });
    }
    initPagination(){
        if (window.location.pathname == '/service-list') {
            let section = new Section('orders', true);
            section.show();
        }
    }
    mobileActionsInit(){
        const modalWindow = $(`#${$('#mobile-actions-btn').data('target')}`)
        modalWindow.removeClass('d-flex');
        modalWindow.addClass('d-none');
        $('#mobile-actions-btn').off('click').on('click', ()=>{
            if (modalWindow.hasClass('d-flex')) {
                modalWindow.addClass('d-none');
                modalWindow.removeClass('d-flex');
            } else {
                modalWindow.removeClass('d-none');
                modalWindow.addClass('d-flex');
            }
            const top = $('#mobile-actions-btn').offset().top + 40;
            const right = window.innerWidth - $('#mobile-actions-btn')[0].getBoundingClientRect().right;
            modalWindow.css({
                'opacity': 1,
                'display': 'flex',
                'right': right,
                'top': top,
            });
            const popupOffset = modalWindow[0].getBoundingClientRect();
            if (popupOffset.height + popupOffset.top > window.innerHeight + window.scrollY / 4) {
                modalWindow.css({
                    'right': right + 40,
                    'top': window.innerHeight + window.scrollY - popupOffset.height - 20
                });
            }
        })
    }
}
